import { render, staticRenderFns } from "./registersinglemodal.vue?vue&type=template&id=20c3c188&"
import script from "./registersinglemodal.vue?vue&type=script&lang=js&"
export * from "./registersinglemodal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports